import { useState } from 'react'

/** superadmin 검수용 퀴즈 ID: 누르면 복사, 옆 버튼은 레거시 어드민에서 연다. */
export function InlineDebugId({ quizId }: { quizId: string }) {
  const [copied, setCopied] = useState(false)
  const handleCopy = () => {
    navigator.clipboard.writeText(quizId)
    setCopied(true)
    setTimeout(() => setCopied(false), 1500)
  }
  return (
    <span className="inline-flex items-center gap-0.5 text-xs font-mono">
      <button
        type="button"
        onClick={handleCopy}
        className="px-1.5 py-0.5 text-slate-500 bg-slate-100 rounded-l hover:bg-slate-200 hover:text-slate-700 transition-colors"
        title="Copy quiz ID"
      >
        {copied ? 'copied!' : quizId}
      </button>
      <button
        type="button"
        onClick={() => window.open(`https://adm.quebon.tv/quiz?type=&category=id&by=modified&findText=${quizId}`, '_blank')}
        className="px-1 py-0.5 text-slate-500 bg-slate-100 rounded-r hover:bg-slate-200 hover:text-slate-700 transition-colors"
        title="View in legacy admin"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-3.5 h-3.5">
          <path fillRule="evenodd" d="M4.25 5.5a.75.75 0 0 0-.75.75v8.5c0 .414.336.75.75.75h8.5a.75.75 0 0 0 .75-.75v-4a.75.75 0 0 1 1.5 0v4A2.25 2.25 0 0 1 12.75 17h-8.5A2.25 2.25 0 0 1 2 14.75v-8.5A2.25 2.25 0 0 1 4.25 4h5a.75.75 0 0 1 0 1.5h-5Zm7.25-.75a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0V6.31l-5.47 5.47a.75.75 0 1 1-1.06-1.06l5.47-5.47H12.25a.75.75 0 0 1-.75-.75Z" clipRule="evenodd" />
        </svg>
      </button>
    </span>
  )
}
